// Same "real photo" test as PlansScreen/DiscoverScreen (and
// functions/profileReminders.js hasRealProfilePhoto): an uploaded photo has a
// storage path or a Firebase Storage URL; generated/default avatars don't.
export function hasRealProfilePhoto(profile?: {
  photo?: string;
  profilePhotoURL?: string;
  profileImage?: string;
  photoPath?: string;
  profileImagePath?: string;
  profilePhotoPath?: string;
} | null): boolean {
  const photo = profile?.profilePhotoURL || profile?.profileImage || profile?.photo || '';
  const path = profile?.profileImagePath || profile?.photoPath || profile?.profilePhotoPath || '';
  return Boolean(
    path.trim() ||
    photo.includes('firebasestorage.googleapis.com') ||
    photo.includes('/profileImages/') ||
    photo.includes('/users/'),
  );
}
